export default __webpack_public_path__ + "static/img-social-contributions-heading-9db4c4951156fefff350426c9cb9488b.avif";